export const levelDescriptions = {
    0: {
      header: "Kompetensnivå 0",
      content:
        "Jag har ännu inte kompetens inom detta område. Jag har nyligen tilldelats ansvarsområden som omfattar kompetensen i fråga, eller så är jag inte skyldig att tillämpa eller visa denna kompetens i mitt arbete.",
    },
    1: {
      header: "Kompetensnivå 1",
      content:
        "Jag har de grundläggande kunskaperna som krävs för jobbet. Jag har uppnått åtminstone denna nivå inom områdets grundutbildning.",
    },
    2: {
      header: "Kompetensnivå 2",
      content:
        "Jag har en gedigen kunskapsbas inom kompetensområdet och tillämpar den på ett mångsidigt sätt i min vardag.",
    },
    3: {
      header: "Kompetensnivå 3",
      content:
        "Jag har mångsidig kompetens inom området. Jag har en omfattande helhetsbild av kompetensområdet. Jag har en bred förståelse av området, tänker och agerar kreativt och utvecklar och identifierar nya lösningar och verksamhetssätt inom detta kompetensområde.",
    },
  };
  
  